<template>
  <div class="imagePlaceholder">
    <div class="imagePlaceholder__image">
      <logo />
    </div>
  </div>
</template>
<script>
import Logo from '~/components/Logo';

export default {
  name: 'ImagePlaceholder',
  components: {
    Logo,
  },
};
</script>
<style lang="scss">
.imagePlaceholder {
  $root: &;
  opacity: 0.2;
  filter: grayscale(1);
  max-width: 100%;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  &__image {
    max-width: 80%;
  }
}
</style>
